import React from "react";
import { AdminSideNav } from "./AdminSideNav";
import type { AdminRouteMap } from "../../pages/AdminAppPage/types";

export type AdminLayoutProps = {
  children: React.ReactNode;
  routes: AdminRouteMap;
};

export const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  routes,
}) => (
  <div className="flex min-h-screen">
    <AdminSideNav routes={routes} />

    <div className="flex-1 min-w-0 md:ml-64">
      <main className="ds-container ds-main-below-app-header px-4 pb-8 sm:pb-6">
        {children}
      </main>
    </div>
  </div>
);
